import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import ErrorIcon from '../ErrorIcon'
import WarningIcon from '../WarningIcon'

const DieselPerCow: React.FC = () => {
  const { control, clearErrors, setError } = useFormContext()

  const watchDieselConsumption = useWatch({ control, name: 'dieselConsumption' })
  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })

  const dieselConsPerCowPerYear = useMemo(() => {

    if (watchDieselConsumption && watchCowsNumber) {
      const dieselConsumption = Math.floor(parseFloat(watchDieselConsumption?.toString()?.replace(',', '.')) / watchCowsNumber)
      if (dieselConsumption > 100) {
        setError('dieselCowConsumption', { message: 'Der Dieselverbrauch pro Kuh und Jahr darf maximal 100 Liter betragen.' })
      } else if (dieselConsumption <= 0) {
        setError('dieselCowConsumption', { message: 'Der Dieselverbrauch pro Kuh und Jahr muss mindestens 1 Liter betragen.' })
      } else {
        clearErrors('dieselCowConsumption')
      }
      return dieselConsumption
    }

    return 0
  }, [watchCowsNumber, watchDieselConsumption])

  return <Form.Field>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
        <div>{'Liter pro Kuh u. Jahr'}</div>
        {(dieselConsPerCowPerYear < 20 || dieselConsPerCowPerYear > 60) && <WarningIcon
          control={control}
          name='dieselCowConsumption'
          content={'Der Dieselverbrauch pro Kuh und Jahr liegt außerhalb der normalen Bereiche von mind. 20 Liter und max. 60 Liter.'}
        />}
        <ErrorIcon
          control={control}
          name={'dieselCowConsumption'}
        />
      </label>
      <div>{`${dieselConsPerCowPerYear} Liter pro Kuh u. Jahr`}</div>
    </MilkProductionField>
  </Form.Field>
}
export default DieselPerCow